import { render } from "./TargetCompanies.vue?vue&type=template&id=1b0756a9&scoped=true"
import script from "./TargetCompanies.vue?vue&type=script&lang=js"
export * from "./TargetCompanies.vue?vue&type=script&lang=js"

import "./TargetCompanies.vue?vue&type=style&index=0&id=1b0756a9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0756a9"]])

export default __exports__